import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'trim',
  standalone: true,
})
export class TrimPipe implements PipeTransform {
  transform(value: string, max: number): string {
    if (String(value).length <= Number(max)) {
      return value;
    } else {
      return String(value).slice(0, max) + '...';
    }
  }
}
